export class StringUtil {
  static OrientationLandscape = 'landscape'
  static OrientationPortrait = 'portrait'
  static Orientations = [StringUtil.OrientationLandscape, StringUtil.OrientationPortrait]

  public static toFixed(num: number, fixedSize = 2): string {
    num = parseFloat(num.toFixed(fixedSize)) // 避免那些 0.00 的情况
    return Number.isInteger(num) ? num.toString() : num.toFixed(fixedSize)
  }

  /***
   * 数字变成string
   * 1k以下正常
   * 1k以上 1100 以下显示 1k
   * 1234 显示 1.2k, 依次类推
   */
  public static numberToShortK(num: number): string {
    if (num < 1000) {
      return `${num}`
    } else {
      const hundred = Math.floor(num / 100)
      const k = Math.floor(hundred / 10)
      const minor = hundred % 10
      // console.log(minor)
      let minorStr = ''
      if (minor > 0) {
        minorStr = `.${minor}`
      }
      return `${k}${minorStr}k`
    }
  }

  public static buildUuid(): string {
    // generate uuid
    // https://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0
      const v = c === 'x' ? r : (r & 0x3) | 0x8
      return v.toString(16)
    })
  }

  public static padZero(num: number, size = 2): string {
    const numSize = `${num}`.length
    if (numSize > size) {
      size = numSize
    }
    return `0000000${num}`.slice(-1 * size)
  }

  // 生成几位数字
  public static randomNum(size = 4) {
    let result = ''
    for (let i = 0; i < size; i++) {
      result += Math.floor(Math.random() * 10)
    }
    return result
  }

  public static capitalizeFirstLetter(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1)
  }

  public static isValidUrl(_url: string) {
    try {
      new URL(_url)
      return true
    } catch (e) {
      return false
    }
  }

  public static isIncludedEmoji(value: string) {
    return value.match(/\p{Emoji_Presentation}/gu)
  }

  public static isHasSpecialCharacter(value: string) {
    return value.match(new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？]"))
  }

  public static onlyIncludedLetters(value: string) {
    return value.match(/^[a-z]+$/i)
  }

  public static onlyIncludedNumbers(value: string) {
    return value.match(/^[0-9]+$/)
  }

  public static onlyIncludedLettersAndNumbers(value: string) {
    return value.match(/^[a-z0-9]+$/i)
  }

  public static validClazzNoteName(value: string) {
    return value === '' ? true : value.match(new RegExp('^[\u4E00-\u9FA5A-Za-z0-9.]+$'))
  }

  public static validChineseCharacter(value: string) {
    return value === '' ? true : value.match(new RegExp('^[\u4E00-\u9FA5]'))
  }

  public static validateChinaMobilePhoneNumber(phone: string) {
    // see: https://github.com/VincentSit/ChinaMobilePhoneNumberRegex
    return /^(?:\+?86)?1(?:3\d{3}|5[^4\D]\d{2}|8\d{3}|7(?:[0-35-9]\d{2}|4(?:0\d|1[0-2]|9\d))|9[0-35-9]\d{2}|6[2567]\d{2}|4[579]\d{2})\d{6}$/.test(
      phone
    )
  }

  public static validateIdentityCardNumber(idCard: string) {
    return /^[0-9X]{18}$/.test(idCard)
  }

  public static validateUniformSocialCreditCode(code: string) {
    return /^[0-9A-Z]{18}$/.test(code)
  }

  /**
   * 判断带星的手机号和原始手机号是否相同
   * @param plainPhone 原始手机号
   * @param briefPhone 简要手机号中间5位是星
   * @returns 除星之外其他是否相同
   */
  public static isSamePhone(plainPhone: string, briefPhone: string): boolean {
    return plainPhone.slice(0, 2) === briefPhone.slice(0, 2) && plainPhone.slice(7) === briefPhone.slice(7)
  }

  public static formatBriefPhone(plainPhone: string) {
    return plainPhone
      .split('')
      .map((w, i) => (i > 2 && i < 7 ? '*' : w))
      .join('')
  }

  // 判断是否手机号
  public static isPhone(plainPhone: string): boolean {
    return !!plainPhone && plainPhone.length === 11
  }

  // 构建query内容
  public static buildQueryString(obj: any): string {
    return Object.keys(obj)
      .map((key) => {
        // if (!obj[key]) {
        //   return ''
        // }
        return this.encodeRFC3986URIComponent(key) + '=' + this.encodeRFC3986URIComponent(obj[key])
      }) // .filter(Boolean)
      .join('&')
  }

  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent#encoding_for_rfc3986
  // 对于一些字符的修复
  public static encodeRFC3986URIComponent(str: string) {
    return encodeURIComponent(str).replace(/[!'()*]/g, (c) => `%${c.charCodeAt(0).toString(16).toUpperCase()}`)
  }

  // 构建url
  public static appendQueryString2Url(url: string, queryString: string): string {
    if (!queryString) {
      return url
    }
    if (url.includes('?')) {
      return url + '&' + queryString
    } else {
      return url + '?' + queryString
    }
  }

  public static textOverflowEllipsis(text: string, maxLength: number) {
    if (text) {
      let textArray = [...text]

      if (textArray.length > maxLength) {
        textArray = textArray.slice(0, maxLength)
        textArray.push('...')
      }

      return textArray.join('')
    }

    return text
  }

  public static shortShownOfArray(items: string[], suffix: string, none = '无') {
    if (!items.length) return none
    if (items.length === 1) return items[0]
    return `${items[0]}等${items.length}个${suffix}`
  }

  /**
   *
   * @param num 0 ~ 25
   * @returns A ~ Z
   */
  public static number2Alphabet(num: number) {
    return String.fromCharCode(num + 65)
  }

  /**
   *
   * @param tpl 'xxx{{ pos1 }}xxx'
   * @param obj { pos1: value1 }
   * @returns 'xxxvalue1xxx'
   */
  public static buildStrFromTemplate(tpl: string, obj: Record<string, any>) {
    const segments = tpl.split(/{{|}}/)

    for (let i = 1; i < segments.length; i += 2) {
      segments[i] = obj[segments[i].trim()]
    }

    return segments.join('')
  }

  public static splitByNumberBoundary(text: string) {
    const result: string[] = []

    const numbers = [...(text.match(/\d+(\.\d+)?/g) || [])]

    if (!numbers.length) {
      return [text]
    }

    const strings = text.split(new RegExp(numbers.join('|')))

    for (let i = 0; i < strings.length; i++) {
      result.push(strings[i] || '')
      result.push(numbers[i] || '')
    }

    // remove empty string from the tail.
    for (let i = result.length - 1; i >= 0; i--) {
      if (!result[i]) {
        result.splice(i, 1)
      } else {
        break
      }
    }

    return result
  }

  public static formatNumberWithCommas(number: number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }
}
